import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { themeOptions } from "./typography";
import { fontSize, padding, width } from "@mui/system";

const baseOptions = {

  palette: {
    primary: {
      main: "#fff", // Customize this color as needed
    },
    secondary: {
      main: "#404040", // Customize this color as needed
    },
    background: {
      main: "#080031", // Customize this color as needed
    },
    text: {
      primary: "#080031",
      secondary: "#fff",
      fontSize: "14px"
    },
    // Add more color definitions as needed
  },
  components: {
    MuiPickersCalendarHeader: {
      styleOverrides: {
        switchViewButton: {
          backgroundColor: "#22242A",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#323741",
          },
        },

        root: {
          // background: "red"
        }
      },

    },
    MuiPickersPopper: {
      styleOverrides: {
        paper: {
          backgroundColor: "#484E5C !important"
        }
      }
    },

    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          background: "#191b1f",
          color: "#fff",

          "&:hover": {
            background: "#323741",
            color: "#fff",

          },
          marginRight: "0px",
          "& .MuiSvgIcon": {
            root: {
              color: "#fff"
            }
          }
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          fontSize: "20px",
          color: "#757575 !important",
          padding: "12px",
          width: "40px",
          height: "40px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: "#474747",
          height: "45px",
          borderRadius: "10px !important",
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {

        // "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        //   border: "1px solid rgba(0, 0, 0, 0.1)",
        // },
        root: {
          background: "#24252761 !important",
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#dfdadaad', // default border color (white)
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#fff !important', // border color on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#efefef', // border color when focused
          },
          height: '45px !importent',
        },
        input: {
          borderRadius: "10px",
          color: "#fff",
          padding: "14px 14px",
          fontSize: "14px",
          fontWeight: "300",
          background: "rgba(0, 0, 0, 0.02)",
          "&:-webkit-autofill": {
            "-webkit-background-clip": "text !important",
            // transitionDelay: "9999s",
            "caret-color": "transparent",
            "-webkit-box-shadow": "0 0 0 100px transparent inset",
            "-webkit-text-fill-color": "#fff",
          },
          "&:-internal-autofill-selected": {
            color: "#fff",
          },
          "&.Mui-disabled": {
            color: "#fff !important",
            "-webkit-text-fill-color": "rgb(255 246 246)",
          }
        },
        inputMultiline: {
          padding: "1px !important",
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&::before": {
            display: "none",
          },
          "&::after": {
            display: "none",
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "30px",

        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        outlined: {
          padding: "20px",
          width: "100%",
          backgroundColor: "#323741",
        },
        elevation1: {
          backgroundColor: `#3237419e`,
          borderRadius: "20px",
          border: "1px solid rgba(255, 255, 255, 0.15)",
          padding: "20px",
          boxShadow: "none",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
        },
        elevation2: {
          background: "#323741",
          borderRadius: "10px",
          padding: "15px",
          boxShadow: "0px 10px 40px 0px rgba(0, 0, 0, 0.16)",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "#22242A",
            transition: "all 0.5s ease"
          },
        },
        elevation3: {
          backgroundColor: `#22242A`,
          borderRadius: "20px",
          border: "1px solid rgba(255, 255, 255, 0.15)",
          padding: "20px",
          boxShadow: "none",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
        },
        root: {
          boxShadow: "none",
          color: "unset"
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { position: "unset", color: "#fff" },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          // borderRadius: "20px",
          width: "unset"
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          background: "rgb(59 84 165)",
          "&:hover": {
            backgroundColor: "none",
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          background: "rgba(43, 145, 239, 0.1)",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: "#323741 !important",
          // "&:hover": {
          //   backgroundColor: "#323741",
          // },
          "&:nth-of-type(odd)": {
            // Override the odd rows' background color
            backgroundColor: "#484e5c !important",

          },
          "&:last-child": {
            // borderBottom: "none",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          padding: "16px 6px",
          fontWeight: "500",
          color: "#fff",
          backgroundColor: "#22242a",
          whiteSpace: "pre",
          fontSize: "14px",
          textAlign: "left",
        },
        body: {
          color: "#fff",
          whiteSpace: "pre",
          fontSize: "14px",
          fontWeight: "500",
          textAlign: "left",
        },
        root: {
          borderBottom: "0px solid #fff",
          textAlign: "left",
          color: "#fff",
          borderSpacing: "10px",
          padding: "7px"
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: 99999,
        },
        paper: {
          backgroundColor: "#323741",
        }
      },
    },

    MuiListItem: {
      styleOverrides: {
        root: {
          alignItems: "self-start",
          padding: "10px 20px 10px 20px",
        },
        gutters: {
          // paddingLeft: 0,
        },
      },
    },

    MuiAccordion: {
      styleOverrides: {
        root: {
          padding: "0px",
          borderRadius: "10px",
          background: "#4E9BC4",
          boxShadow: "3px 5px 11.100000381469727px 2px rgba(0, 0, 0, 0.1)",
          "&:last-of-type": {
            borderRadius: "10px",
          },
          "&:first-of-type": {
            borderRadius: "10px",
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "rgba(0, 0, 0, 0.15 ",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: "4px",
          fontSize: "12px",
          color: "rgb(255 187 85)",
          "&.Mui-checked": { color: "rgb(255 187 85)" },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          paddingBottom: "0",
        },
      },
    },
    MuiListItemSecondaryAction: {
      styleOverrides: {
        root: {
          right: 0,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paperScrollPaper: {
          Width: 450,
          maxWidth: "100%",
        },
        paper: {
          borderRadius: "10px",
          background: "#323741",
          filter: "none",
        },
        paperWidthSm: {
          maxWidth: "522px !important",
        },
        paperWidthXs: {
          maxWidth: "522px !important",
        },
        root: {
          background: "#22252ae8"
        }
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "20px 18px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          // backgroundColor: "rgba(63, 59, 122, 1)",
          textAlign: "center",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "20px 35px 0px",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: "#f27171 !important",
            fontSize: "14px",
          },
          marginRight: "0px",
          marginLeft: "0px",
        },
      },
    },

    MuiPaginationItem: {
      styleOverrides: {
        root: {
          backgroundColor: "rgb(78 155 196)",
          "&.Mui-disabled": {
            opacity: 0.38,
            background: "rgb(78 155 196)",
            color: "#fff",
          },
          "&:hover": {
            color: "#fff",
            background: "#3237419e",
          },
          "&.Mui-selected": {
            backgroundColor: "#22242A",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#323741",
              color: "#fff"
            },
          },
        },
      },
    },


    MuiPickersDay: {
      styleOverrides: {
        root: {
          backgroundColor: "#323741",
          color: " #fff",

          "&.Mui-selected": {
            backgroundColor: "#22242A",
            color: " #fff",
            "&:hover": {
              backgroundColor: "#323741",
              color: " #fff"
            },

          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          fontSize: "12px",
          fontWeight: "400",
          lineHeight: "18px",
          letterSpacing: "0px",
          textAlign: "left",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedSecondary: {

          color: "#3B54A5",
          padding: "10px 35px",
          textTransform: "capitalize",
          fontSize: "14px",
          fontWeight: "500",
          borderRadius: "10px",
          border: "1px solid #3B54A5",
          whiteSpace: "pre",
          "&:hover": {
            boxShadow: "none",
            color: "#fff",
            background: "#3B54A5",
            border: "1px solid #fff",
          },
        },
        containedOutline: {
          color: "#fff",
          padding: "10px 35px",
          textTransform: "capitalize",
          fontSize: "14px",
          fontWeight: "500",
          borderRadius: "10px",
          border: "1px solid #4E9BC4",
          background: "#4E9BC4",
          whiteSpace: "pre",
          "&:hover": {
            boxShadow: "none",
            color: "#fff",
            // background: "transparent",
            border: "1px solid #4E9BC4",
          },
        },
        containedSizeSmall: {
          color: "#FFBB55",
          padding: "8px 20px",
          textTransform: "capitalize",
          fontSize: "14px",
          fontWeight: "500",
          borderRadius: "10px",
          background: "#323741",
          border: "1px solid #484e5c",
          whiteSpace: "pre",
          "&:hover": {
            boxShadow: "none",
            color: "#fff",
            background: "#CB3743",
          },
        },
        containedPrimary: {
          color: "#474747",
          padding: "10px 35px",
          textTransform: "capitalize",
          fontSize: "14px",
          fontWeight: "500",
          borderRadius: "10px",
          border: "1px solid transparent",
          background: "#FFBB55",
          whiteSpace: "pre",
          "&:hover": {
            boxShadow: "none",
            color: "#474747",
            background: "#fff",
            border: "1px solid #FFBB55",
          },
        },
        containedPrimarySmall: {
          color: "#474747",
          padding: "7px 15px",
          textTransform: "capitalize",
          fontSize: "12px",
          fontWeight: "500",
          borderRadius: "10px",
          border: "1px solid transparent",
          background: "#FFBB55",
          whiteSpace: "pre",
          "&:hover": {
            boxShadow: "none",
            color: "#474747",
            background: "#fff",
            border: "1px solid #FFBB55",
          },
        },
        outlinedPrimary: {
          color: "#fff",
          padding: "5px 16px",
          textTransform: "capitalize",
          fontSize: "14px",
          fontWeight: "500",
          borderRadius: "10px",
          background: "#484e5c",
          border: "1px solid #484e5c",
          whiteSpace: "pre",
          "&:hover": {
            boxShadow: "none",
            color: "#fff",
            background: "#323741",
          },
        },
        outlinedSecondary: {
          color: "#fff",
          padding: "10px 35px",
          textTransform: "capitalize",
          fontSize: "14px",
          fontWeight: "500",
          borderRadius: "10px",
          border: "1px solid #22242A",
          whiteSpace: "pre",
          // border: "1px solid #FFBB55",
          backgroundColor: "#22242A",
          "&:hover": {
            boxShadow: "none",
            color: "#fff",
            background: "#323741",
            border: "1px solid #323741",
          },
        },
        outlined: {
          color: "#2B91EF",
          borderRadius: "unset !important",
          border: "2px solid #3f51b524 !important",
          textTransform: "capitalize",
          whiteSpace: "pre",
          padding: "5px 3px 5px !important",
          fontSize: "16px",
          fontWeight: "400",
          minWidth: "40px",
          "&:hover": {
            color: "#000 !important",
            background: "#dfdfdf !important",
            border: "2px solid #3F51B5 !important"
          },
        },
        activeoutlined: {
          padding: "5px 3px 5px !important",
          minWidth: "40px",
          color: "#000 !important",
          background: "#dfdfdf !important",
          border: "2px solid #3F51B5 !important"

        },
        root: {
          "&:hover": {
            background: "#2d3037",
          },
        },
      },

    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          lineHeight: "20px",
          "&.Mui-disabled": {
            color: " #ccc !important",
            background: "#3c4e5c",
            filter: "blur(0.5px)"
          },
        },
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#ffbb55",
          "&.Mui-checked": {
            color: " #3b54a5db !important",
          },
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: "0px"
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paperAnchorDockedLeft: {
          borderRight: "0",
        },
        paper: {
          width: "250px",
          backgroundColor: "#22242A",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // border: "1px solid #E8E8E8",
          backgroundColor: "transparent",
          height: "45px !important",
          borderRadius: "10px !important",
        },
        select: {
          color: "#fff !important",
          backgroundColor: "transparent",
          fontSize: 15,
        },
        icon: {
          color: "#fff !important",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: { top: "dd !important" },
        list: {
          background: "#22242a",
          color: "#fff",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingLeft: "20px",
          "&:hover": {
            background: "#2d3037",
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          backgroundColor: "#a7a2ee",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        backdrop: {
          background: "transparent !important",
        },
      },
    },

    MuiToolbar: {
      styleOverrides: {
        // root: {
        //   padding: "0px 65px !important",
        //   "@media (max-width: 780px)": {
        //     padding: "0px 16px !important",
        //   },
        // },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none !important",
          cursor: "pointer",
        },
      },
    },
  },
};

export const createCustomTheme = (config = {}) => {
  console.log("data12", { ...baseOptions })
  let theme = createTheme({ ...baseOptions, ...themeOptions });

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
